import { createSelector } from "@reduxjs/toolkit";
import { discoveryPanelsSelector } from "./discoveryPanels.selector";

export const interactionsSelector = createSelector(
  discoveryPanelsSelector,
  state => state.interactions
); 